import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { checkProduct } from "src/utils/storage/product";
import { useGetTotalNxacList } from "src/hooks/api/nxac/useGetTotalNxacList";
import { useUserNxacList } from "src/hooks/api/nxac/useUserNxacList";
import { useState } from "react";
import { useRouter } from "src/hooks/useRouter";
import { dateFormatUtcToYMD } from "src/utils/dateManagement";
import { PayPalButton } from "react-paypal-button-v2";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { useTranslation } from "react-i18next";

interface IChangePayTermModalProps {
  modal: any;
  priceType: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  serviceList: any;
  driveUserPerPrice: any;
  basicUserPerPriceYear: any;
  basicUserPerPrice: any;
  basicPlusUserPerPrice: any;
  plusPlusUserPerPrice: any;
  plusUserPerPriceYear: any;
  plusUserPerPrice: any;
  changePrice: any;
  changeNextPayDate: any;
  changePriceIncTax: any;
  confirmPrice: (orderId: any, type: any, authorizationID: any) => void;
  toggleModalConfirmPayTerm: () => void;
  changePayTerm: any;
  checkConfirmPayTerm: () => void;
}
// 결제 주기 변경 모달 (추후 다시 만들것!!)
const ChangePayTermModal = ({
  modal,
  priceType,
  handleChange,
  serviceList,
  driveUserPerPrice,
  basicUserPerPriceYear,
  basicUserPerPrice,
  basicPlusUserPerPrice,
  plusPlusUserPerPrice,
  plusUserPerPriceYear,
  plusUserPerPrice,
  changePrice,
  changeNextPayDate,
  changePriceIncTax,
  confirmPrice,
  toggleModalConfirmPayTerm,
  changePayTerm,
  checkConfirmPayTerm,
}: // goPrint,
IChangePayTermModalProps) => {
  const checkProductName = checkProduct("WRAPSODY_ECO");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const route = useRouter();
  const { nxacList } = useGetTotalNxacList({});
  const { checkNxacList } = useUserNxacList({});
  const goPromotion = () => {
    route.goSitePromotion({ type: "ask" });
  };
  const setPaymentCycle = () => {
    if (priceType === "drive") {
      return parseInt(driveUserPerPrice);
    } else if (priceType === "basic") {
      return parseInt(basicUserPerPrice);
    } else if (priceType === "basicPlus") {
      return parseInt(basicPlusUserPerPrice);
    } else if (priceType === "plus") {
      return parseInt(plusUserPerPrice);
    } else if (priceType === "plusPlus") {
      return parseInt(plusPlusUserPerPrice);
    } else {
      return -1;
    }
  };
  const { togglePayInfoModal } = useBillStatement();
  const { t } = useTranslation();
  return (
    <>
      <Modal
        show={modal.payTerm}
        onHide={() => togglePayInfoModal({ info: "payTerm" })}
        className="confirm__period"
        style={{ opacity: 1 }}
      >
        <Modal.Header closeButton>
          <h4>
            {t("siteManagement.paymentHistory.popUp.changePaymentCycle.title")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <FormGroup className="mg mb-0">
            <Form.Check
              className="box box__gray radio"
              style={{ marginBottom: "15px" }}
            >
              <Form.Check.Label>
                <Form.Check.Input
                  type="radio"
                  name="changePayTerm"
                  value="month"
                  checked={changePayTerm === "month"}
                  onChange={handleChange}
                />
                <span className="item__left3">
                  <b>
                    {t(
                      "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_month"
                    )}
                  </b>
                </span>
                <span className="item__left3 text weight--500">
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_per_user")
                    : ""}
                  <NumberFormat
                    num={
                      setPaymentCycle()
                      // priceType === 'plus'
                      //   ? plusUserPerPrice
                      //   : basicUserPerPrice
                    }
                    currency={"WON"}
                  />
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_monthly")
                    : ""}
                  <br />
                  <span className="text weight--350">
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.annual_sum")
                      : ""}
                    &nbsp;
                    <NumberFormat
                      num={
                        setPaymentCycle() * 12
                        // (priceType === 'plus'
                        //   ? plusUserPerPrice
                        //   : basicUserPerPrice) * 12
                      }
                      currency={serviceList?.currency}
                    />
                  </span>
                </span>
              </Form.Check.Label>
            </Form.Check>
            <Form.Check className="box box__gray radio">
              <Form.Check.Label>
                <Form.Check.Input
                  type="radio"
                  name="changePayTerm"
                  value="year"
                  checked={changePayTerm === "year"}
                  onChange={handleChange}
                />
                <span className="item__left3">
                  <b>
                    {t(
                      "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_annual"
                    )}
                  </b>
                </span>
                <span className="item__left2 text weight--500">
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_per_user")
                    : ""}
                  <NumberFormat
                    num={
                      serviceList?.priceType === "plus"
                        ? plusUserPerPriceYear
                        : basicUserPerPriceYear
                    }
                    currency={serviceList?.currency}
                  />
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_monthly")
                    : ""}
                  <br />
                  <span className="text weight--350">
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.annual_sum")
                      : ""}
                    &nbsp;
                    <NumberFormat
                      num={
                        (serviceList?.priceType === "plus"
                          ? plusUserPerPriceYear
                          : basicUserPerPriceYear) * 12
                      }
                      currency={serviceList?.currency}
                    />
                  </span>
                </span>
                <div className="item__right">
                  <span className="label label--green">
                    <NumberFormat
                      num={
                        ((serviceList?.priceType === "plus"
                          ? plusUserPerPrice
                          : basicUserPerPrice) -
                          (serviceList?.priceType === "plus"
                            ? plusUserPerPriceYear
                            : basicUserPerPriceYear)) *
                        12
                      }
                      currency={serviceList?.currency}
                    />
                  </span>
                </div>
              </Form.Check.Label>
            </Form.Check>
          </FormGroup>
          <hr />
          <FormGroup>
            <p className="text text--gray text--13">
              {/* 결제 주기 변경 관련 안내 */}
              <span>
                {t(
                  "siteManagement.paymentHistory.popUp.changePaymentCycle.info.Msg1",
                  dateFormatUtcToYMD(changeNextPayDate)
                )}
              </span>
              <br />
              {changePayTerm === "year" ? (
                <span>
                  {/* {t(
                    "siteManagement.paymentHistory.popUp.changePaymentCycle.info.Msg3",
                    serviceList[0]?.currency === "WON"
                      ? t("subscriptionType.fee.won")
                      : t("subscriptionType.dollar") +
                          t("subscriptionType.fee.dollar"),
                    Number(
                      // serviceList?.licenseCount *
                      //   (priceType === "plus"
                      //     ? plusUserPerPriceYear
                      //     : basicUserPerPriceYear) *
                      setPaymentCycle() * 12
                    ).toLocaleString()
                  )} */}
                </span>
              ) : (
                <span>
                  {/* {t(
                    "siteManagement.paymentHistory.popUp.changePaymentCycle.info.Msg2",
                    serviceList[0]?.currency === "WON"
                      ? t("subscriptionType.fee.won")
                      : t("subscriptionType.dollar") +
                          t("subscriptionType.fee.dollar"),
                    Number(
                      // serviceList?.licenseCount *
                      //   (priceType === "plus"
                      //     ? plusUserPerPrice
                      //     : basicUserPerPrice)
                      setPaymentCycle()
                    ).toLocaleString()
                  )} */}
                </span>
              )}
              <br />
              <br />
              <span>
                {t(
                  "siteManagement.paymentHistory.popUp.changePaymentCycle.info.Msg4",
                  dateFormatUtcToYMD(changeNextPayDate)
                )}
              </span>
            </p>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          {changePrice > 0 ? (
            <PayPalButton
              createOrder={(data: any, actions: any) => {
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        value: changePriceIncTax,
                      },
                    },
                  ],
                });
              }}
              onApprove={(data: any, actions: any) => {
                // Capture the funds from the transaction
                return actions.order
                  .authorize()
                  .then(function (authorization: any) {
                    // Show a success message to your buyer
                    confirmPrice(
                      data.orderID,
                      "user",
                      authorization.purchase_units[0].payments.authorizations[0]
                        .id
                    );
                  });
              }}
            />
          ) : (
            ""
          )}
          <Button className="btn btn-gray" onClick={toggleModalConfirmPayTerm}>
            {t("common.cancelBtn")}
          </Button>
          <Button className="btn btn-green" onClick={checkConfirmPayTerm}>
            {t("common.okBtn")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePayTermModal;
